module.exports = __webpack_public_path__ + "static/media/undo.144aa79f.svg";